import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'

import SearchIcon from '../../../shared/components/icons/search'
import PolygonIcon from '../../../shared/components/icons/polygon'

class FiltersPolygons extends React.Component {
  static propTypes = {
    locationParams: PropTypes.object.isRequired,
    items: PropTypes.object.isRequired,
    makeSearchLink: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    const { locationParams } = props
    this.state = {
      value:
        locationParams && locationParams.poly_count
          ? locationParams.poly_count
          : ''
    }
  }

  onChange(event) {
    this.setState({ value: event.target.value })
  }

  onSubmit() {
    const { locationParams, makeSearchLink } = this.props

    let nextQuery = Object.assign({}, locationParams, {
      poly_count: this.state.value
    })

    delete nextQuery.page

    this.props.history.push(makeSearchLink(nextQuery))
  }

  onEnter(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.onSubmit()
    }
  }

  componentWillReceiveProps(nextProps) {
    const nextQuery = nextProps.locationParams

    if (nextQuery && nextQuery.poly_count !== this.state.value) {
      this.setState({ value: nextQuery.poly_count || '' })
    }
  }

  render() {
    const { items } = this.props
    const placeholder = `${items.avg}, ${items.min}-${items.max}`

    return (
      <div className="search-facet--no-margin" id="polygons-filter">
        <div className="search-facet-box--start">
          <div className="search-facet-box__inner">
            <h2 className="search-facet-box__heading">
              <PolygonIcon /> Polygons
            </h2>
            <div className="search-facet-range__inputs">
              <div className="search-facet-range__input--single">
                <label
                  className="fds-u-is-visually-hidden"
                  htmlFor="poly_count"
                >
                  Polygons
                </label>
                <input
                  type="text"
                  id="poly_count"
                  className="e-input"
                  placeholder={placeholder}
                  pattern="(\d+\s*\-\s*\d+|\d+)"
                  value={this.state.value}
                  onChange={this.onChange.bind(this)}
                  onKeyPress={this.onEnter.bind(this)}
                />
              </div>
              <div className="search-facet-range__input--submit">
                <button
                  type="button"
                  className="fds-c-button fds-u-p0"
                  onClick={this.onSubmit.bind(this)}
                >
                  <SearchIcon title="Apply" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export const FiltersPolygonsComponent = FiltersPolygons
export default withRouter(FiltersPolygons)
